const state = () => ({
  loading: false,
  legalDocuments: {}
});

const getters = {
  loading(state) {
    return state.loading;
  },
  legalDocuments(state) {
    return state.legalDocuments;
  }
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setLegalDocuments(state, payload) {
    state.legalDocuments[payload.category] = payload.data;
  }
};

const actions = {
  setLegalDocuments({ commit }, payload) {
    commit('setLegalDocuments', payload);
  },
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  }
};

export const legalDocuments = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
